import React, { useState } from 'react';
import {
  READING_TIPS_COUNT,
  READING_TIPS_GROUPS,
  READING_TIPS_STORAGE_KEY,
} from './readingComprehensionTips';

const readStoredOpenState = () => {
  try {
    const stored = localStorage.getItem(READING_TIPS_STORAGE_KEY);
    if (stored === null) return true;
    return stored === 'true';
  } catch {
    return true;
  }
};

const persistOpenState = (isOpen) => {
  try {
    localStorage.setItem(READING_TIPS_STORAGE_KEY, String(isOpen));
  } catch {
    // Ignore quota or private-mode failures.
  }
};

export default function ReadingTipsPanel() {
  const [showTips, setShowTips] = useState(readStoredOpenState);

  const toggleTips = () => {
    setShowTips((prev) => {
      const next = !prev;
      persistOpenState(next);
      return next;
    });
  };

  return (
    <section style={{ marginBottom: '3rem' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '1rem',
          flexWrap: 'wrap',
          marginBottom: showTips ? '1.25rem' : 0,
        }}
      >
        <div>
          <h2
            style={{
              color: 'var(--liwaza-on-surface)',
              margin: 0,
            }}
          >
            Reading Comprehension Tips & Strategies
          </h2>
          <p
            style={{
              color: 'var(--liwaza-on-surface-variant)',
              margin: '0.4rem 0 0 0',
              fontSize: '0.92rem',
            }}
          >
            {READING_TIPS_COUNT} tips · about 5 min read
          </p>
        </div>
        <button
          type="button"
          onClick={toggleTips}
          style={{
            background: 'var(--liwaza-primary-container)',
            color: 'var(--liwaza-on-primary-container)',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '0.85rem',
            fontWeight: 500,
          }}
        >
          {showTips ? 'Hide Tips' : 'Show Tips'}
        </button>
      </div>

      {showTips &&
        READING_TIPS_GROUPS.map((group) => (
          <div key={group.id} style={{ marginBottom: '1.75rem' }}>
            <h3
              style={{
                margin: '0 0 0.85rem 0',
                color: 'var(--liwaza-on-surface)',
                fontSize: '1.05rem',
              }}
            >
              {group.title}
            </h3>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  'repeat(auto-fit, minmax(min(100%, 420px), 1fr))',
                gap: '1rem',
              }}
            >
              {group.tips.map((tip) => (
                <article
                  key={tip.id}
                  style={{
                    background: 'var(--liwaza-surface-container)',
                    border: '1px solid var(--liwaza-outline-variant)',
                    borderRadius: '14px',
                    padding: '1.15rem 1.2rem',
                  }}
                >
                  <h4
                    style={{
                      margin: '0 0 0.75rem 0',
                      color: 'var(--liwaza-on-surface)',
                      fontSize: '1.02rem',
                      lineHeight: 1.35,
                    }}
                  >
                    {tip.title}
                  </h4>

                  <p
                    style={{
                      margin: '0 0 0.9rem 0',
                      color: 'var(--liwaza-on-surface-variant)',
                      fontSize: '0.9rem',
                      lineHeight: 1.6,
                    }}
                  >
                    {tip.rule}
                  </p>

                  <div style={{ marginBottom: '0.9rem' }}>
                    <div
                      style={{
                        fontSize: '0.72rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.08em',
                        color: 'var(--liwaza-primary)',
                        fontWeight: 700,
                        marginBottom: '0.4rem',
                      }}
                    >
                      How to do it
                    </div>
                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: '1.15rem',
                        color: 'var(--liwaza-on-surface-variant)',
                        fontSize: '0.88rem',
                        lineHeight: 1.55,
                      }}
                    >
                      {tip.howTo.map((item) => (
                        <li key={item} style={{ marginBottom: '0.3rem' }}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div
                    style={{
                      marginBottom: '0.9rem',
                      padding: '0.75rem 0.85rem',
                      borderRadius: '10px',
                      background: 'var(--liwaza-surface-container-lowest)',
                      border: '1px solid var(--liwaza-outline-variant)',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '0.72rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.08em',
                        color: 'var(--liwaza-primary)',
                        fontWeight: 700,
                        marginBottom: '0.35rem',
                      }}
                    >
                      Example
                    </div>
                    <p
                      style={{
                        margin: 0,
                        color: 'var(--liwaza-on-surface-variant)',
                        fontSize: '0.88rem',
                        lineHeight: 1.55,
                      }}
                    >
                      {tip.example}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: '0.75rem 0.85rem',
                      borderRadius: '10px',
                      borderLeft: '4px solid rgba(255, 107, 53, 0.65)',
                      background:
                        'linear-gradient(135deg, rgba(255, 107, 53, 0.07), rgba(247, 201, 72, 0.06))',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '0.72rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.08em',
                        color: '#d95d2c',
                        fontWeight: 700,
                        marginBottom: '0.35rem',
                      }}
                    >
                      Exam trap
                    </div>
                    <p
                      style={{
                        margin: 0,
                        color: 'var(--liwaza-on-surface-variant)',
                        fontSize: '0.88rem',
                        lineHeight: 1.55,
                      }}
                    >
                      {tip.examTrap}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))}
    </section>
  );
}
